import { pointerOutsideOfPreview } from "@atlaskit/pragmatic-drag-and-drop/element/pointer-outside-of-preview";
import { setCustomNativeDragPreview } from "@atlaskit/pragmatic-drag-and-drop/element/set-custom-native-drag-preview";
import type { DefaultTheme } from "styled-components";

// The native drag ghost is replaced with a solid preview chip — the default
// browser preview is a translucent snapshot of the dragged row, which reads
// as broken against the app background. Shared by the Explorer resource drag
// and the nav bar's transform reordering.
export function setDragPreviewChip({
  nativeSetDragImage,
  theme,
  name,
}: {
  nativeSetDragImage: Parameters<
    typeof setCustomNativeDragPreview
  >[0]["nativeSetDragImage"];
  theme: DefaultTheme;
  name: string;
}) {
  setCustomNativeDragPreview({
    nativeSetDragImage,
    getOffset: pointerOutsideOfPreview({ x: "8px", y: "8px" }),
    render: ({ container }) => {
      const chip = document.createElement("div");
      chip.textContent = name;
      Object.assign(chip.style, {
        display: "inline-flex",
        alignItems: "center",
        height: "32px",
        padding: "0 12px",
        background: theme.cards1Background,
        border: `1px solid ${theme.semanticMainPrimary}`,
        borderRadius: "6px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        font: "500 14px/1.2 Inter, sans-serif",
        color: theme.semanticTextBody,
        whiteSpace: "nowrap",
      });
      container.appendChild(chip);
    },
  });
}
